import api from "../Api";
import routes from "../constants/ApiRoutesConstants";

export async function GetSuppliers(params) {
  const res = await api.get(routes.SUPPLIERS, {
    params: params,
  });
  return res;
}

export async function GetUserAssociatedSupplierForAdmin(params) {
  const res = await api.get(routes.USER_ASSOCIATED_SUPPLIER, {
    params: params,
  });

  return res;
}

export async function PatchUserAssociatedSupplierForAdmin(params) {
  const res = await api.patch(routes.PATCH_USER_ASSOCIATED_SUPPLIER, params);
  return res;
}

export async function PatchToggleFavouriteSupplier(user_supplier_id) {
  const res = await api.patch(
    routes.TOGGLE_FAVOURITE_SUPPLIER,
    {},
    {
      params: { user_supplier_id: user_supplier_id },
    }
  );
  return res;
}
